import { Component, Inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { BackEndService } from 'src/app/backend-service';
import { OfferOverviewModel, WidgetUserFilter } from 'src/app/classes';
import { FilterType, FilterTypes } from 'src/app/components/edit/edit-userfilter/edit-userfilter.component';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { Offer } from 'src/app/lib/offer/classes';
import { CreateOfferComponent } from 'src/app/lib/offer/components/dialog/create-offer/create-offer.component';
import { AbstractListWidgetInner, WidgetInnerData, WidgetInnerView } from 'src/app/widget-inner';

@Component({
  selector: 'app-offer-widget-inner',
  templateUrl: './offer-widget-inner.component.html',
  styleUrls: ['./offer-widget-inner.component.css']
})
export class OfferWidgetInnerComponent extends AbstractListWidgetInner<OfferOverviewModel> {

  currentFilterType: FilterType<number> = FilterTypes.find(x => x.value == "Offer");

  @Input() set data(data: WidgetInnerData) {
    this._data = data;
    this.loadContent();
  }
  get data(): WidgetInnerData {
    return this._data;
  }

  defaultView: boolean = true;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _backEndService: BackEndService,
    private _router: Router,
    private _dialog: MatDialog
  ) {
    super();
    this.sortAttribute = "offertitle";
  }

  addOffer = () => this._dialog.open(CreateOfferComponent, {
    panelClass: 'no-padding-dialog-container'
  });

  editOffer(offer: Offer) {
    this._router.navigate(["/offer-details", offer.offerid]);
  }

  loadContent() {
    this._backEndService.get("api/offer/current").subscribe((result: OfferOverviewModel[]) => {
      this.entries = result;
      this.sortEntries();
      this.defaultView = true;
    });
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Neues Angebot anlegen'),
        icon: () => of('add'),
        onClick: () => {
          this.addOffer();
          return of(null);
        }
      } as WidgetInnerView
    ]);
  }

  receiveUserFilter(filter: WidgetUserFilter) {
    if (!filter.filteR1) return;
    this._backEndService.get("api/offer/search/" + filter.filteR1.filterid).subscribe((result: OfferOverviewModel[]) => {
      this.entries = result;
      this.sortEntries();
      this.defaultView = false;
    });
  }

}
